import { Sparkles } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { SUGGESTED_QUERIES } from '../lib/suggestedQueries';
import { useAnalyticsStore } from '../stores/analyticsStore';
import { useNaturalLanguageQuery } from '../hooks/useNaturalLanguageQuery';

export function SuggestedQueries() {
  const { setNaturalLanguageInput, setMode } = useAnalyticsStore();
  const translateQuery = useNaturalLanguageQuery();

  const handleSelectQuery = (queryText: string) => {
    setMode('natural_language');
    setNaturalLanguageInput(queryText);
    translateQuery.mutate(queryText);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Sparkles className="h-5 w-5 text-warning" />
        <h3 className="text-lg font-semibold">Suggested Queries</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {SUGGESTED_QUERIES.map((suggestion, index) => (
          <Card
            key={index}
            className="p-3 cursor-pointer hover:bg-accent transition-colors"
            onClick={() => handleSelectQuery(suggestion.text)}
          >
            <p className="text-sm">{suggestion.text}</p>
          </Card>
        ))}
      </div>
    </div>
  );
}
